export const CREATE_ACCOUNT = '/create_account';
export const LOGIN = '/login';
export const PASSWORD_RESET = '/password/reset';
